import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import backButtonLogo from "../../assets/images/back-button.svg";
import BouncerLogo from "../../assets/images/bouncer-logo2.svg";
import LanguageSelect from "../LanguageSelect/LanguageSelect";
import webhookEditInPortal from "../../assets/images/webhookEditInPortal.png";

import "./VerificationWebhookIntegration.css";

const VerificationWebhookIntegration = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const webhookEventTypesExample = `type AuditEventType = "BIOMETRIC" | "ID_SCAN" | "OCR";

interface WebhookEventBase {
  organizationId: string;
  sessionToken: string;
  audit_event_type: AuditEventType;
}

type WebhookEvent =
  | (WebhookEventBase & {
      audit_event_type: "BIOMETRIC";
      payload: { auditHigh: string; auditLow: string };
    })
  | (WebhookEventBase & {
      audit_event_type: "ID_SCAN";
      payload: { front: string; back: string };
    })
  | (WebhookEventBase & {
      audit_event_type: "OCR";
      payload: { ocr: Record<string, string> };
    });`;

  return (
    <div className="WebhookOrganizationUrl">
      <div className="WebhookOrganizationUrl__container">
        <div className="Banner">
          <img
            onClick={() => {
              window.location.href = "https://www.bouncer.global/";
            }}
            className="BackButton"
            src={backButtonLogo}
            alt="Back"
          />
          <LanguageSelect />
        </div>

        <div className="Header">
          <div style={{ fontSize: "25px" }}>
            {t("webhookOrganizationUrlInt.mainTitle")}
          </div>
          <img
            style={{ width: "250px", cursor: "pointer" }}
            src={BouncerLogo}
            alt="Bouncer Logo"
          />
        </div>

        <div className="Subheader">
          <div style={{ fontSize: "25px", marginBottom: "30px" }}>
            {t("webhookOrganizationUrlInt.title")}
          </div>
          <div
            className="SubheaderParagraph"
            style={{ fontSize: "18px", textAlign: "center" }}
          >
            {t("webhookOrganizationUrlInt.subtitle")}
          </div>
        </div>

        <div className="StepFirstLayout">
          <div>
            <div className="StepFirstLayout-number">
              {t("webhookOrganizationUrlInt.step1")}:
            </div>
            <div className="StepFirstLayout-title">
              {t("webhookOrganizationUrlInt.step1Title")}
            </div>
          </div>

          <div
            className="StepFirstLayout-content"
            style={{ fontSize: "18px", color: "black" }}
          >
            <div
              data-i18n="[html]webhookOrganizationUrlInt.step1Description"
              dangerouslySetInnerHTML={{
                __html: t("webhookOrganizationUrlInt.step1Description", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
            <div
              className="StepFirstLayout-note"
              data-i18n="[html]webhookOrganizationUrlInt.step1PortalNote"
              dangerouslySetInnerHTML={{
                __html: t("webhookOrganizationUrlInt.step1PortalNote", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
            <img
              className="StepFirstLayout-image"
              src={webhookEditInPortal}
              alt={t("webhookOrganizationUrlInt.step1ImageAlt")}
            />
            <div className="StepFirstLayout-imageCaption">
              {t("webhookOrganizationUrlInt.step1ImageCaption")}
            </div>
          </div>
        </div>

        <div className="StepFirstLayout">
          <div>
            <div className="StepFirstLayout-number">
              {t("webhookOrganizationUrlInt.step2")}:
            </div>
            <div className="StepFirstLayout-title">
              {t("webhookOrganizationUrlInt.step2Title")}
            </div>
          </div>

          <div
            className="StepFirstLayout-content"
            style={{ fontSize: "18px", color: "black" }}
          >
            <div
              data-i18n="[html]webhookOrganizationUrlInt.step2Description"
              dangerouslySetInnerHTML={{
                __html: t("webhookOrganizationUrlInt.step2Description", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
            <pre className="code">{webhookEventTypesExample}</pre>
          </div>
        </div>

        <div className="StepFirstLayout">
          <div>
            <div className="StepFirstLayout-title">
              {t("webhookOrganizationUrlInt.eventTypePayloadTitle")}
            </div>
          </div>
          <div
            className="StepFirstLayout-content"
            style={{ fontSize: "18px", color: "black" }}
            dangerouslySetInnerHTML={{
              __html: t(
                "webhookOrganizationUrlInt.eventTypePayloadDescription",
                {
                  interpolation: { escapeValue: false },
                }
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VerificationWebhookIntegration;
